module.exports = __webpack_public_path__ + "images/Spinner.306f48198a398f39919d974ea4a7a03e.svg";